module.exports = __webpack_public_path__ + "img/default_avator.9fd91d66.jpeg";